export default {
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js